export default __webpack_public_path__ + "static/media/search.inline.9608e264.svg";